"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var InputRadio_styles_1 = __importDefault(require("./InputRadio.styles"));
var FormErrorMessage_1 = __importDefault(require("../FormErrorMessage/FormErrorMessage"));
var InputRadio = function (_a) {
    var label = _a.label, id = _a.id, options = _a.options, value = _a.value, error = _a.error, valueChanged = _a.valueChanged;
    return (react_1.default.createElement(InputRadio_styles_1.default, null,
        react_1.default.createElement("p", { className: "label" }, label),
        react_1.default.createElement("div", { className: "options" }, options.map(function (option, index) { return (react_1.default.createElement("div", { key: index, className: "option" },
            react_1.default.createElement("input", { type: "radio", id: option.value, name: id + "_" + (index + 1), checked: value === option.value, onChange: function (e) {
                    valueChanged(id, e.currentTarget.id);
                } }),
            react_1.default.createElement("label", { htmlFor: option.value }, option.label))); })),
        react_1.default.createElement(FormErrorMessage_1.default, null, error)));
};
exports.default = InputRadio;
